var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuToolsAbTestGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(1.0002, 0, 0, 1.0002, -0.199991, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\xE1bana-de-iconos-Copy",
    transform: "translate(-1402.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_copy_masa",
    className: "st0",
    d: "M1434.4,641.3v-281c0-3.3,2.7-6,6-6h280.9c3.3,0,6,2.7,6,6v281c0,3.3-2.7,6-6,6h-280.9 C1437,647.3,1434.4,644.6,1434.4,641.3z M1864.9,464.3h-105.2V360.3c0-21.1-17.2-38.3-38.3-38.3h-280.9 c-21.1,0-38.3,17.2-38.3,38.3v281c0,21.1,17.2,38.3,38.3,38.3h103.9v105.2c0,20.4,16.6,37.1,37.1,37.1h283.5 c20.4,0,37.1-16.6,37.1-37.1V501.4C1902,480.9,1885.4,464.3,1864.9,464.3z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "#86888C"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#86888C",
      fontFamily: "Arial, sans-serif",
      fontSize: 250,
      whiteSpace: "pre"
    },
    transform: "matrix(1.0002, 0, 0, 1.0002, 0.403676, -0.050017)",
    x: 88.352,
    y: 266.156
  }, "A"), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Arial, sans-serif",
      fontSize: 250,
      whiteSpace: "pre"
    },
    transform: "matrix(1.0002, 0, 0, 1.0002, 0.403676, -0.050017)",
    x: 244.08,
    y: 418.944
  }, "B", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 244.0800018310547,
    dy: "1em"
  }, "\u200B"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuToolsAbTestGray);
export default __webpack_public_path__ + "static/media/ic-menu-tools-ab-test-gray.add18073ef480485554ca65cf79c3637.svg";
export { ForwardRef as ReactComponent };